import tsl from '../../app/tsl';
import moment from 'moment-timezone';

export function isEmpty(val) {
  return (val === undefined || val === null || val === '' || val.length && val.length === 0) ? true : tsl('validations.value_must_be_empty');
}

export function isNotEmpty(val) {
  return isEmpty(val) === true ? tsl('validations.value_is_required') : true;
}

export function isValueSelected(val) {
  return (isEmpty(val) !== true && val === 0) ? tsl('validations.please_select_a_value') : true;
}

export function isNumeric(val) {
  return (isEmpty(val) === true || +val == val) ? true : tsl('validations.value_is_not_numeric');
}

export function isInteger(val) {
  return (isEmpty(val) === true || +val === parseInt(val)) ? true : tsl('validations.value_is_not_integer');
}

export function isDate(val) {
  return isNotEmpty(val) === true && moment(val) === 'Invalid Date' ? tsl('validations.is_not_a_date') : true;
}

export function createIsNotSoonerThan(otherField) {
  return (val) => isEmpty(otherField.value) === true || isEmpty(val) === true || isDate(val) === true && moment(val) >= moment(otherField.value) ? true : tsl('validations.value_must_be_after', { ['other_field.label']: otherField.label })
}

export function createIsNotLaterThan(otherField) {
  return (val) => isEmpty(otherField.value) === true || isEmpty(val) === true || isDate(val) === true && moment(val) <= moment(otherField.value) ? true : tsl('validations.value_must_be_before', { ['other_field.label']: otherField.label })
}

export function min(min) {
  return (val) => {
    if (isEmpty(val) === true) {
      return true;
    }

    if (isNumeric(val) === true) {
      return val >= min ? true : tsl('validations.minimum_value', { min });
    }

    return val.length >= min ? true : tsl('validations.minimum_length', { min, length: val.length });
  }
}

export function max(max) {
  return (val) => {
    if (isEmpty(val) === true) {
      return true;
    }

    if (isNumeric(val) === true) {
      return val <= max ? true : tsl('validations.maximum_value', { max });
    }

    return val.length <= max ? true : tsl('validations.maximum_length', { max, length: val.length });
  }
}

export function isURL(val) {
  if (isEmpty(val) === true) return true;

  try {
    new URL(val);
  } catch (_) {
    return tsl('validations.invalid_url');
  }

  return true;
}

export default {
  isEmpty,
  isNotEmpty,
  isValueSelected,
  isNumeric,
  isInteger,

  createIsNotSoonerThan,
  createIsNotLaterThan,
  isURL,
  min,
  max
}


// WEBPACK FOOTER //
// ./components/forms/validations.js